module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "col1"
    }
  }, [_vm._v("The story which follows was inspired by an event which took place in our country not many years ago. However, it is a work of fiction and any resemblance to living persons or actual places is accidental.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e9cbfe7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795317392_epub_col1_r1.vue
// module id = 75
// module chunks = 0